export default {
  secretKey: process.env.REACT_APP_SECRET_KEY,
  secretIv: process.env.REACT_APP_SECRET_IV,
  apiUrl: process.env.REACT_APP_API_URL,
  lineLiffId: process.env.REACT_APP_LINE_LIFF_ID,
  bearerToken: process.env.REACT_APP_BEARER_TOKEN,
  productImgUrl: process.env.REACT_APP_PRODUCT_IMAGE_URL
}